import classNames from "classnames";
import { SearchIcon } from "~/common/icons/SearchIcon";

export function SearchBarFrame({
  className,
  children,
  onClick,
}: {
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
}) {
  return (
    <div className="tw:flex tw:justify-end tw:items-center tw:w-full">
      <div className="tw:flex tw:min-w-[400px]">
        <div
          className={classNames(
            "tw:!border-1 tw:!border-gray-200 tw:bg-white tw:rounded-md tw:rounded-tr-none tw:rounded-br-none tw:w-full tw:h-12 tw:pl-4 tw:text-md tw:text-gray-400 tw:whitespace-nowrap tw:align-middle tw:flex tw:items-center",
            className,
          )}
        >
          {children}
        </div>
        <div
          onClick={onClick}
          className="tw:bg-cn-btn-primary tw:px-3 tw:py-4 tw:rounded-md tw:rounded-tl-none tw:rounded-bl-none"
        >
          <SearchIcon className="tw:fill-white tw:w-4 tw:h-4" />
        </div>
      </div>
    </div>
  );
}
